import React, { createContext, useCallback, useContext, useState } from "react";

const Ctx = createContext<(msg: string) => void>(() => {});
export const useToast = () => useContext(Ctx);
export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [msg, setMsg] = useState<string | null>(null);
  const show = useCallback((m: string) => { setMsg(m); setTimeout(() => setMsg(null), 2600); }, []);
  return <Ctx.Provider value={show}>{children}<div role="status" aria-live="polite">{msg ? <div className="toast">{msg}</div> : null}</div></Ctx.Provider>;
};
